<template>
    <div class="p-3 row justify-content-center" v-if="!error">
        <el-card class="col-12 print-sheet" :header="travel.id ? `Viagem ${travel.id}`:'Procurando Viagem'">
            <el-skeleton :loading="loading" animated :rows="12">
                <template #default>
                    <el-form :disabled="saving" v-if="travel" :model="travel" label-position="top" ref="formRef">
                        <ElDescriptions
                            class="margin-top"
                            title="Detalhes da viagem"
                            :column="3"
                            :size="'default'"
                            border
                        >
                            <ElDescriptionsItem>
                                <template #label>
                                    <div class="cell-item">
                                        Empresa
                                    </div>
                                </template>
                                {{ travel.car?.travel_company?.name }}
                            </ElDescriptionsItem>
                            <ElDescriptionsItem>
                                <template #label>
                                    <div class="cell-item">
                                        Data e Hora de partida
                                    </div>
                                </template>
                                {{ new Date(travel.departure).toLocaleString() }}
                            </ElDescriptionsItem>
                            <ElDescriptionsItem>
                                <template #label>
                                    <div class="cell-item">
                                        Lugares restantes
                                    </div>
                                </template>
                                {{ travel.remaining_places?.length }}
                            </ElDescriptionsItem>
                            <ElDescriptionsItem>
                                <template #label>
                                    <div class="cell-item">
                                        Rota definida
                                    </div>
                                </template>
                                {{ travel.route?.name }}
                            </ElDescriptionsItem>
                            <ElDescriptionsItem>
                                <template #label>
                                    <div class="cell-item">
                                        Carro
                                    </div>
                                </template>
                                {{ travel.car?.name }} [{{ travel.car?.plate }}]
                            </ElDescriptionsItem>
                            <ElDescriptionsItem>
                                <template #label>
                                    <div class="cell-item">
                                        Capacidade do Carro
                                    </div>
                                </template>
                                {{ travel.car?.places }} lugares
                            </ElDescriptionsItem>
                        </ElDescriptions>
                    </el-form>
                    <h5>Passageiros</h5>
                    <PersonalTable class="no-print"  :loading="loading" :height="450" :showRows="10" :cols="[
                        {label: 'Cod', prop: 'id'},
                        {label: 'Passageiro', prop: 'name'},
                        {label: 'Cadeira Nr', prop: 'place'},
                        {label: 'Preço (MT)', prop: 'price'},
                    ]" :data="tickets" >
                        <ElTableColumn label="Data de nascimento" class-name="auto" :min-width="150">
                            <template #default="data">
                                {{ new Date(data.row.birthday).toLocaleDateString("af") }}
                            </template>
                        </ElTableColumn>
                        <ElTableColumn label="Viagem" class-name="auto" :min-width="150">
                            <template #default="data">
                                <ElText type="success" style="text-align: right">{{ data.row.trip_segment.from?.name }} - {{ data.row.trip_segment.to?.name }}</ElText>
                            </template>
                        </ElTableColumn>
                    </PersonalTable>
                    
                    <table class="no-screen table" :cellpadding="5">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Nome do passageiro</th>
                                <th>Cadeira</th>
                                <th>Origem - Destino</th>
                                <th>Data e hora da compra</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="ticket in tickets" :key="ticket.id">
                                <td>{{ ticket.id }}</td>
                                <td>{{ ticket.name }}</td>
                                <td>{{ ticket.place }}</td>
                                <td>{{ ticket.trip_segment?.from?.name }} - {{ ticket.trip_segment?.to?.name }}</td>
                                <td>{{ new Date(ticket.created_at ?? 0).toLocaleString('af') }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="py-3">
                        <ElButton class="no-print" :type="'primary'" plain @click="print">
                            <span>Imprimir lista &emsp;</span>
                            <ElIcon><Printer /></ElIcon>
                        </ElButton>
                        <ElButton class="no-print" :type="'primary'" plain @click="back">
                            <ElIcon><ArrowLeft /></ElIcon>
                            Voltar
                        </ElButton>
                    </div>
                </template>
            </el-skeleton>
        </el-card>
    </div>
</template>

<script setup lang="ts">
    import Api from '@/services/api';
    import { Travel, TravelTicket } from '@/services/types';
    import { ElTableColumn, ElIcon, ElMessage, FormInstance, ElDescriptions, ElDescriptionsItem, ElButton } from 'element-plus';
    import { nextTick, onBeforeMount, reactive, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import "leaflet/dist/leaflet.css";
    import PersonalTable from '@/components/PersonalTable.vue';

    const route = useRoute()
    const id = route.params.id

    const router = useRouter()
    const back = () => {
        router.push("/companies-dashboard/travel")
    }
    const loading = ref<boolean>(true)
    const error = ref<boolean>(false)
    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()
    const tickets = ref<Array<TravelTicket>>([])

    const travel = reactive<Travel>({
        car_id: 0,
        departure: new Date(),
        route_id: 0,
        active: 1,
        remaining_places: []
    })

    const print = () => {
        window.print()
        console.log("Printing")
        nextTick()
    }

    const password = sessionStorage.getItem('password')
    const phone = sessionStorage.getItem('phone')

    const getTrip = async (id: number | string) => {
        const res = await Api.get(`companies/travel/${id}?password=${password}&phone=${phone}`)
        if (res.status == 200) {
            const data = res.data.trip
            travel.active = true
            travel.car = data.car
            travel.car_id = data.car_id
            travel.departure = data.departure
            travel.id = data.id
            travel.remaining_places = data.remaining_places
            travel.route = data.route
            travel.route_id = data.route_id
            travel.user = data.user
    
            error.value = false
            console.log(data)
        } else {
            error.value = true
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }
    
    const getTickets = async (id: number | string) => {
        const res = await Api.get(`companies/tickets/${id}?password=${password}&phone=${phone}`)
        if (res.status == 200) {
            console.log(res)
            tickets.value = res.data.tickets
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
    }

    onBeforeMount(async () => {
        loading.value = true
        await Promise.all([
            getTrip(id as string),
            getTickets(id as string)
        ])
        // await getCars(travel.car?.travel_company_id as number)
        loading.value = false
    })
</script>

<style lang="css" scoped>
    table.list-tickets {
        width: 100% !important;
    }
    table.list-tickets td {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    table.list-tickets tr {
        border-bottom: 1px solid gray;
    }
    .table {
        width: 100%;
    }
    .table td, .table th, .table {
        border: 1px solid gray;
    }
    @media screen {
        .no-screen {
            display: none !important;
        } 
    }
    @media print {
        .print-sheet {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1026;
            width: 100vw !important;
            min-height: 100vh !important;
        }
        .no-print {
            display: none !important;
        }
        /* .no-screen {
            display: block;
        } */
    }
</style>